import { POST_PAY, POST_PAY_EMBEDDED, setPayEmbeddedData } from '../../../actions/app/pay/pay.action';
import { setError, setLoader, setStep } from '../../../actions/app/ui/ui.actions';
import { setTrackAction } from '../../../actions/core/analytics/analytics.actions';
import { apiRequest, API_ERROR, API_SUCCESS } from '../../../actions/core/api/api.actions';
import { formatDataANForApi } from "@amo/core/utils/formatDataANForApi.js";
import { setNotification } from '../../../actions/core/notifications/notifications.actions.js';
import {setSivError} from "../../../actions/app/pay/pay.action.js";
import {FILL} from "../../../actions/app/fill/fill.actions.js";
import { getSlugStep } from '../../../../utils/function';

export const payMiddleware = (dispatch) => (next) => (action) => {
    next(action);

    const { payload } = action;

    switch (action.type) {
        case POST_PAY:
            const body = formatDataANForApi(payload.body);

            next([
                apiRequest({ body, method: 'POST', url: payload.data, entity: POST_PAY }),
                setLoader({ state: true, entity: POST_PAY }),
            ]);

            break;

        case `${POST_PAY} ${API_SUCCESS}`:
            next([
                setError({ state: false, entity: POST_PAY }),
                setLoader({ state: false, entity: POST_PAY }),
                setTrackAction({
                    event: 'click',
                    actionGoogle: 'clickButton',
                    libelle: 'Je finalise la souscription',
                    categorie: 'GO-TO-PAY',
                }),
            ]);

            console.log('payload.data', payload.data)

            window.location = payload.data;
            break;

        case `${POST_PAY} ${API_ERROR}`:
            const errorMessage = action.payload.data?.response?.data?.error;

            if (errorMessage && errorMessage.includes("Veuillez vérifier la saisie de")) {
                next([
                    setSivError(true),
                    setNotification({
                        entity: FILL,
                        html: errorMessage,
                        title: 'Attention !',
                        type: 'error'
                    }),
                    setError({ state: true, entity: POST_PAY }),
                    setLoader({ state: false, entity: POST_PAY })
                ]);
            } else {
                next([
                    setNotification({
                        entity: FILL,
                        html: errorMessage,
                        title: 'Attention !',
                        type: 'error'
                    }),
                    setError({ state: true, entity: POST_PAY }),
                    setLoader({ state: false, entity: POST_PAY })
                ]);
            }
            break;


        case POST_PAY_EMBEDDED:
            next([
                apiRequest({
                    body: formatDataANForApi(payload.body),
                    method: 'POST',
                    url: payload.data,
                    entity: POST_PAY_EMBEDDED,
                }),
                setLoader({ state: true, entity: POST_PAY_EMBEDDED }),
            ]);
            break;

        case `${POST_PAY_EMBEDDED} ${API_SUCCESS}`:
            next([
                setPayEmbeddedData(payload.data),
                setError({ state: false, entity: POST_PAY_EMBEDDED }),
                setLoader({ state: false, entity: POST_PAY_EMBEDDED }),
                setStep({ step: getSlugStep('paiement') }),
            ]);
            break;

        case `${POST_PAY_EMBEDDED} ${API_ERROR}`:
            const errorMessageEmbedded = action.payload.data?.response?.data?.error;

            // Contrôle SIV (AMODEV-27392) : on reste sur le récap' et on arme sivError
            // pour que le conseiller puisse confirmer l'immatriculation et repasser.
            next([
                ...(errorMessageEmbedded?.includes('Veuillez vérifier la saisie de') ? [setSivError(true)] : []),
                setNotification({
                    entity: FILL,
                    html: errorMessageEmbedded || 'Erreur lors de l\'initialisation du paiement.',
                    title: 'Attention !',
                    type: 'error',
                }),
                setError({ state: true, entity: POST_PAY_EMBEDDED }),
                setLoader({ state: false, entity: POST_PAY_EMBEDDED }),
            ]);
            break;

        default:
            return null;
    }
};
